import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import _MuiInput from '@mui/material/Input';
import { styled } from '@mui/material/styles';
import React__default, { useRef, useCallback } from 'react';
import 'date-fns';
import { isNumberInput } from '../../utils/isNumberInput.js';
import Hint from '../Hint/Hint.js';

const customInputProps = ['inactive', 'modifiedManually', 'withBorder', 'isNumberType'];
const MuiInput = styled(_MuiInput, {
    shouldForwardProp: prop => !customInputProps.includes(prop),
}) `
  ${({ theme, inactive, value, modifiedManually, error, placeholder }) => `
    color: ${inactive ? theme.palette.N20.main : ''};
    background-color: ${inactive ? 'transparent' : ''};
    color: ${modifiedManually && value && !error ? theme.palette.warning.main : ''} !important;
    &:hover {
      color: ${theme.palette.primary.main};
    }
    &.Mui-disabled {
      background-color: ${inactive ? '' : theme.palette.N80.main};
    }
    &.Mui-error:before {
      border-color: ${(!value && placeholder) || inactive ? 'transparent' : ''};
    }
  `}
  border: ${({ theme, withBorder }) => withBorder && `1px solid ${theme.palette.N40.main}`};
  ${({ isNumberType, theme }) => isNumberType &&
    `
    text-align: center;
    padding: ${theme.spacing(0.5, 1)};
    &.MuiInputBase-inputSizeSmall {
      minWidth: 16px;
    }
    &.MuiInputBase-inputSizeMedium {
      minWidth: 24px;
    }
    input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
      WebkitAppearance: none;
      display: none;
      margin: 0;
    }
    input[type='number']: {
      MozAppearance: textfield;
    }
  `};
`;
const Input = (_a, ref) => {
    var { disabled, numberParseOption, error, value, hint = '', type, onChange, onFocus, hintDuration, arrow } = _a, rest = __rest(_a, ["disabled", "numberParseOption", "error", "value", "hint", "type", "onChange", "onFocus", "hintDuration", "arrow"]);
    const inputRef = useRef(null);
    const onChangeInternal = useCallback((e) => {
        if (type !== 'number' || isNumberInput(e.target.value, numberParseOption)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(e);
        }
    }, [onChange, type, numberParseOption]);
    const onInternalFocus = useCallback((e) => {
        if (type === 'number' && inputRef.current) {
            inputRef.current.select();
        }
        if (onFocus) {
            onFocus(e);
        }
    }, [onFocus, type]);
    const isNumberType = type === 'number';
    return (jsx(Hint, Object.assign({ title: hint, duration: hintDuration, disabled: !hint.length, arrow: arrow }, { children: jsx(MuiInput, Object.assign({ ref: ref, inputRef: inputRef, disabled: disabled, error: error, value: value, type: isNumberType ? undefined : type, isNumberType: isNumberType, onFocus: onInternalFocus, onChange: onChangeInternal }, rest)) })));
};
var Input$1 = React__default.forwardRef(Input);

export { Input$1 as default };
//# sourceMappingURL=Input.js.map
